<template>
    <b-modal v-model="showModal" size="lg" title="Importar CSV" hide-footer>
        <div class="col-md-12">
            <div class="row">
                <div class="d-flex flex-column">
                    <span class="text-center text-primary" style="font-size: 40px !important;"><i class="mdi  mdi-cloud-upload"></i></span>
                    <h5 class="mt-3 mb-3 font-bold" style="text-align: justify;">
                        Realize a importação da planilha em modelo CSV da instituição financeira Sicredi para preencher as informações automaticamente.
                    </h5>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-md-6">
                    <b-form-group label="Instituição Financeira">
                        <multiselect v-model="selecaoInstituicaoFinanceira" :options="instituicaoFinanceiraLkp" :disabled="true" label="name" track-by="name" />
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <inputCooperado @cooperadoSelecionado="setCooperado"/>
                </div>
            </div>

            <div class="row mb-2">
                <b-form-group label="Arquivo">
                    <input
                      ref="fileInput"
                      @change="tratarArquivo"
                      class="form-control mb-1"
                      type="file"
                      :state="false"
                      :disabled="false"
                      accept=".csv,.CSV"
                    />
                </b-form-group>
            </div>

            <div class="row">
                <div class="col-md-12 col-sm-12 d-flex flex-column flex-md-row justify-content-md-center order-1 order-md-2 mb-2 mb-md-0">
                    <b-button variant="secondary" class="me-md-3 mb-2 mb-md-0" @click="fecharModal">
                      <i class="mdi mdi-arrow-left-circle"></i>
                        Voltar
                    </b-button>
                    <b-button variant="success" @click="salvarArquivo" :disabled="disabledSalvar">
                        <i class="mdi mdi-content-save"></i> Salvar
                        <b-spinner
                          variant="primary"
                          small
                          class="ms-2"
                          v-if="disabledSalvar"
                        ></b-spinner>
                    </b-button>
                </div>
            </div>
        </div>
  </b-modal>
</template>

<script>
import Multiselect       from "vue-multiselect";
import Swal              from "sweetalert2";
import inputCooperado    from "@/components/astec/projetos/lotesImportacao/inputCooperado";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
    mixins    : [clienteRuralMixin],
    components: {
        inputCooperado,
        Multiselect
    },
    data() {
        return {
            showModal     : false,
            disabledSalvar: false,
            instituicaoFinanceiraLkp: [
                { name: "SICREDI [748]", value: 748 },
            ],
            selecaoInstituicaoFinanceira: [
                { name: "SICREDI [748]", value: 748 },
            ],
            arquivo       : null,
            cdPessoa      : null,
            sqUsuario     : null 
        };
    },
    methods: {
        abrirModal() {
            this.showModal = true;
        },
        fecharModal(){
            this.showModal = false;
        },
        async salvarArquivo(){
            this.disabledSalvar = true;
            
            try {
                const extensaoArquivo = this.arquivo && this.arquivo.name
                                      ? this.arquivo.name.substring(this.arquivo.name.lastIndexOf('.') + 1).toLowerCase()
                                      : '';

                if(extensaoArquivo != "csv"){
                    Swal.fire({
                        icon : "warning",
                        title: "Atenção",
                        text : "Apenas arquivos csv são permitidos na importação de projetos!",
                    });
                    
                    return;
                }

                const formData = new FormData();
                formData.append("arquivoImportacao", this.arquivo);
                formData.append("nomeArquivo"      , this.arquivo.name);
                formData.append("tamanhoArquivo"   , this.arquivo.size);
                formData.append("cd_bco"           , this.selecaoInstituicaoFinanceira[0].value);
                formData.append("cd_pessoa"        , this.cdPessoa );

                await this.$http.post("/api/astec/projetos/importarProjetos", formData,{
                    headers: { 'Content-Type': 'multipart/form-data' }
                }).then((response) => {

                    if(response.data.status === true){
                        Swal.fire({
                            icon : "success",
                            title: "Sucesso",
                            text : `O lote ${response.data.data.sqAstecIntegracaoLote} foi importado com sucesso! Total de projetos importados: ${response.data.data.qtdProjetos}.`,
                        }).then(() => {
                            localStorage.setItem('sqAstecIntegracaoLote', response.data.data.sqAstecIntegracaoLote);

                            this.$router.push("/astec/projetos/lotesImportacao/projetosLote");
                        });
                    }

                }).catch((error) =>{

                    if(error.response && error.response.data.status === false){
                        this.$emit('errosImportacao', error.response.data.erros);
                    }else{
                        this.$tools.alerta(error, 'error');
                    }

                });
            } catch (error) {
                this.$tools.alerta(error, 'error');
            } finally {
                this.disabledSalvar = false;
                this.arquivo        = null;

                if(this.$refs.fileInput){
                    this.$refs.fileInput.value = null;
                }
            }
        },
        tratarArquivo(event) {
            this.arquivo = event.target.files[0];
        },
        setCooperado(cooperado) {
            this.cdPessoa = cooperado.value;
        }
    },
};
</script>